import { useNavigation } from '../context/navigation-context-provider';
import { useTranslation } from 'next-i18next';
import { getDesignSystemIconWithFallback } from '../helpers/utils';

export const BackButton = () => {
  const { t } = useTranslation(['shared']);
  const { setState } = useNavigation();

  return (
    <span className="block w-full">
      <button
        type="button"
        className="flex w-full items-center gap-2 py-4"
        onClick={() => {
          setState((prevState) => ({ ...prevState, showMobileSubMenu: null }));
        }}
      >
        <img src={getDesignSystemIconWithFallback('icon-chevron-left.svg')} alt="Icon Left" className="h-3 w-3" />
        <span>{t('topBar_meta_back')}</span>
      </button>
    </span>
  );
};
